import fixedAside from '../components/fixed-aside';
import scrollTo from '../components/scroll-to';
import introMobilePopup from '../components/product-form-mobile-popup';
import galleryPopup from '../components/building-gallery-popup';
import matterportPopup from '../components/building-matterport-popup';
import productBundles from '../components/product-bundles';

export default () => {
  scrollTo(true);
  fixedAside('fixed-aside-container', 'fixed-aside-sticky-bar');
  productBundles();
  introMobilePopup();
  galleryPopup();
  matterportPopup();
}
